"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dobToAge = exports.yearToWeekMonth = exports.monthToWeekYear = exports.weekToMonthYear = exports.unitConversionMap = exports.bytesToKB = exports.MbsToBytes = exports.lbToKg = exports.kgToLb = exports.inToCm = exports.cmToIn = exports.secondsToMinuteSeconds = exports.inchesToFeetInches = void 0;
const helpers_1 = require("./helpers");
const moment_1 = __importDefault(require("moment"));
const validation_1 = require("../validation");
const inchesToFeetInches = (inches, asNumList = false) => {
    const realFeet = inches / 12;
    const _feet = Math.floor(realFeet);
    const _in = Math.round((realFeet - _feet) * 12);
    return asNumList ? [_feet, _in] : _feet + "'" + _in + '"';
};
exports.inchesToFeetInches = inchesToFeetInches;
const secondsToMinuteSeconds = (seconds, asNumList = false) => {
    const realMinute = seconds / 60;
    const minutes = Math.floor(realMinute);
    seconds = Math.round((realMinute - minutes) * 60);
    return asNumList ? [minutes, seconds] : minutes + "m " + seconds + "s";
};
exports.secondsToMinuteSeconds = secondsToMinuteSeconds;
const cmToIn = (valueCm) => (0, helpers_1.round)(valueCm / 2.54, 1);
exports.cmToIn = cmToIn;
const inToCm = (valueIn) => (0, helpers_1.round)(valueIn * 2.54, 1);
exports.inToCm = inToCm;
const kgToLb = (valueKg) => (0, helpers_1.round)(valueKg * 2.205, 1);
exports.kgToLb = kgToLb;
const lbToKg = (valueLb) => (0, helpers_1.round)(valueLb / 2.205, 1);
exports.lbToKg = lbToKg;
const MbsToBytes = (sizeInMbs) => Math.floor(sizeInMbs * 1048576);
exports.MbsToBytes = MbsToBytes;
const bytesToKB = (file_size_bytes) => Math.round(file_size_bytes / 1000);
exports.bytesToKB = bytesToKB;
// metric <-> imperial conversions
const unitConversionMap = (unit, value) => {
    const conversionMap = {
        cm: exports.cmToIn,
        in: exports.inToCm,
        kg: exports.kgToLb,
        lb: exports.lbToKg,
    };
    return conversionMap[unit](value);
};
exports.unitConversionMap = unitConversionMap;
const weekToMonthYear = (weeks) => {
    return {
        months: (0, helpers_1.round)(weeks / 4.345, 2),
        years: (0, helpers_1.round)(weeks / 52.143, 2),
    };
};
exports.weekToMonthYear = weekToMonthYear;
const monthToWeekYear = (months) => {
    return {
        weeks: (0, helpers_1.round)(months * 4.345, 2),
        years: (0, helpers_1.round)(months / 12, 2),
    };
};
exports.monthToWeekYear = monthToWeekYear;
const yearToWeekMonth = (years) => {
    return {
        weeks: (0, helpers_1.round)(years * 52.143, 2),
        months: (0, helpers_1.round)(years * 12, 2),
    };
};
exports.yearToWeekMonth = yearToWeekMonth;
const dobToAge = (dob, ageUnit = validation_1.Time.YEARS) => {
    return (0, moment_1.default)().diff(dob, ageUnit);
};
exports.dobToAge = dobToAge;
//# sourceMappingURL=conversions.js.map